import { render, staticRenderFns } from "./FbTagView.vue?vue&type=template&id=ecdfab5c&scoped=true"
import script from "./FbTagView.vue?vue&type=script&lang=js"
export * from "./FbTagView.vue?vue&type=script&lang=js"
import style0 from "./FbTagView.vue?vue&type=style&index=0&id=ecdfab5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdfab5c",
  null
  
)

export default component.exports